module.exports = __webpack_public_path__ + "select2-spinner_9ed46.gif";


//////////////////
// WEBPACK FOOTER
// ./bower_components/select2/select2-spinner.gif
// module id = 27
// module chunks = 0